var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarFemme2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 494 494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10{fill:none;}.cls-2{fill:#083d77;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#e8dab2;}.cls-5{fill:#ff715b;}.cls-6{fill:#e0a4d5;}.cls-7{fill:#d89cca;}.cls-8{fill:#e2a1d0;}.cls-9{fill:#ebebd3;}.cls-10{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;}.cls-11{fill:#ce84bd;}.cls-12{fill:#e53c4c;}.cls-13{fill:#d4310f;}.cls-14{fill:#ff1d25;opacity:0.19;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 247,
    cy: 247,
    r: 247
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MinDef_ILLU_vectorisation_v3_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_5",
    "data-name": "Calque 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jeune_femme",
    "data-name": "Jeune femme"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 247,
    cy: 247,
    r: 247
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M324,83c18.51,9.79,22.11,38.12,24,53,5.92,46.58-18.07,67.27-22,114-1.76,20.89.15,51.05,18,89-1.24,9.71-6.21,39.4-28,51-31.72,16.89-76-16.86-95-37-45.81-48.54-53.53-133.13-19-194C230.68,108.44,292.87,66.54,324,83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61,398c1-6.16,14-83,48-90,5.64-1.16,11.29-.3,36-3,13.37-1.46,21.19-2.75,30-4,30-4.25,45-6.28,63-6,29.79.46,53.42,7.48,65,11,6.11,1.86,13.95,6.4,27,10,15.78,4.36,20.48,3.16,27,6,11.67,5.09,18,18.24,25,47,10.85,44.63,21.45,90.91,4,150-2.27,7.68-3.4,11.52-5,15-32.71,71.23-203.44,112.84-283,31C43.44,508.88,57,423,61,398Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185,297a359.89,359.89,0,0,0-42,8,43.83,43.83,0,0,1-3,10,41.84,41.84,0,0,1-2,4c-2.88,5.15-3.16,34.43,17,59,23.95,29.18,59.17,33.39,65,34,2.79.29,45.3,4.12,79-26,6.75-6,23.07-21,29-46a81.49,81.49,0,0,0,2-24,233.78,233.78,0,0,0-65-20C232.37,291.05,205.89,294.29,185,297Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M202.81,234.74c-8.14,15.44,5.66,25.25-1.78,46.83-5.95,17.27-17.82,19.77-17.19,32.6.64,13.07,13.53,22.1,18.38,25.49,18.23,12.77,49.26,17.52,63.42,1.78,8.72-9.69,8.37-24.19,8.3-27.27-.28-11.76-5.08-13.47-6.52-24.89-2.36-18.73,9.37-23.52,7.7-39.12-1.46-13.75-12.66-29.74-29.63-33.79C228.11,212.22,209.66,221.77,202.81,234.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M233.82,58.55C265.59,53.2,290.76,68.8,294.28,71c7.81,4.88,24.57,17.08,33.72,39,3,7.26,5.82,17,4.81,49.32-1.59,50.67-1.83,76.43-19.56,99A106.73,106.73,0,0,1,283,284.39a123.2,123.2,0,0,1-53.94-13.64c-23.23-12-36.1-28.26-42.68-36.75-13.63-17.57-40.47-52.18-32-96C161.92,98.92,195.05,65.07,233.82,58.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M226.5,126.5c-2.71,2.77-19.79,20.75-20.5,45.5-.25,8.56,1.57,14.39,10,36,20.75,53.17,26,59.41,24,72-3,19-17.93,23.75-30,40-14.79,19.91-24.22,55.63-1,125a100.27,100.27,0,0,1-40.5-10.5c-6.82-3.44-39.17-19.85-46-51-3.43-15.65.3-30.66,3.5-43.5,4.56-18.31,11.62-30.21,8-33-4.72-3.65-20.3,13.93-26,10-4.71-3.25-.15-19.45,6-32,12.32-25.16,25.21-23.85,33-41,7.71-17-2.46-23.58-6-71-1.93-25.84-2.89-38.75,2-55,1.9-6.31,10.92-36.27,39-53,23-13.69,48.63-12.52,60-12,22.44,1,29.68,7.41,44,2,18.82-7.11,21.12-23.73,31-23,14.36,1,33.4,38,22,58C323.19,117.82,263.75,88.35,226.5,126.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M317.5,48.5c.54.41,13.08,10.2,11,23-1.91,11.75-14.68,17.09-17,18-15.42,6-23.6-5.35-52-6-10.19-.23-19.78-.34-30,5-12.69,6.63-19.13,17.9-22,24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M217.5,75.5c-25.44,6.54-37.76,19.39-43,26-24.73,31.18-14.91,78.21-12,90,6.46,26.17,18.11,37.68,13,58-3.3,13.12-11.69,22.37-18,28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.75,172.67c.72-2-6-8.57-13.27-7.81-7.75.79-13,9.47-11.83,11.1.62.88,2.89-.62,8.73-1.77C246.68,172.17,252.15,174.35,252.75,172.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321,174.57c1.14-1.82-4-9.67-11.25-10.52-7.73-.91-14.73,6.42-14,8.26.42,1,3,0,8.9.18C315.23,172.75,320.08,176.08,321,174.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M288,161c2.4.69-6.75,17.65,1,35,2.75,6.15,6.9,10.75,5,16a11.63,11.63,0,0,1-9,7c-4.11.68-8.72-.81-11-4-3.12-4.37-1.64-10.31,0-16C278.14,184.68,285.2,160.2,288,161Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M299,235a38.47,38.47,0,0,1-9,0c-5.32-.63-5.88-1.84-10-2-3.76-.15-4.71.8-12,2-3.38.55-6.16.84-8,1a21.23,21.23,0,0,0,39-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M264.58,146a6.08,6.08,0,0,1-.94,6c-2.73,3.15-8.6.94-14.22,0-16.68-2.79-28.55,6.06-29.38,4-.72-1.79,8.18-8.8,19-12C248.38,141.22,262.12,140.45,264.58,146Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M298.23,144a8.78,8.78,0,0,0,.61,6c1.75,3.15,5.54.94,9.17,0,10.77-2.78,18.43,6.06,19,4,.47-1.79-5.28-8.8-12.23-12C308.69,139.22,299.81,138.45,298.23,144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M290,237a14.5,14.5,0,0,1-20,0,14.5,14.5,0,0,1,20,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 238.5,
    cy: 203,
    rx: 14.5,
    ry: 11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 315,
    cy: 197.83,
    rx: 10,
    ry: 9.17
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFemme2);
export default __webpack_public_path__ + "static/media/avatar_femme_2.4e28bd05ce54eb261846897812e1cf23.svg";
export { ForwardRef as ReactComponent };